import React, { useEffect, useState, useCallback } from 'react';
import { isProduction } from './isProduction';

export const loadClientComponent = (componentImport) => {
  const ComponentLoader = (props) => {
    const [importedModule, setImportedModule] = useState(null);

    const componentLoaded = !!importedModule?.default;

    const loadComponent = useCallback(async () => {
      if (componentLoaded) return;
      const m = await componentImport();
      if (!isProduction) console.log('trigger module loading');
      if (!m.default) throw new Error('Imported module does not include default export');
      else setImportedModule(m);
    }, [componentLoaded]);

    useEffect(() => {
      //component loaded, we no longer need event listeners
      if (componentLoaded) return;

      if (!isProduction) console.log('client side component loading');
      //we'll fetch component right now
      //keep in mind it needs some time as it is fetched from separate bundle
      loadComponent();
    }, [loadComponent, componentLoaded]);

    if (componentLoaded) {
      if (!isProduction) console.log('LCC: rendering component');
    }

    if (!!componentLoaded) return <importedModule.default {...props} />;
    return null;
  };

  return ComponentLoader;
};
